import React from 'react';
import { GovMessage } from '@gov-design-system-ce/react';
import { MarkdownRender } from '@gov-nx/component/web';
import { useRezaLocale } from '@gov-nx/module/page';
import { Icon } from '@gov-nx/ui/web';

export const RezaNotAllDisplayedMessage = () => {
	const { t } = useRezaLocale();

	return (
		<div className="py-4">
			<GovMessage
				color="primary"
				type="subtle"
				icon={
					<Icon
						type="components"
						name="info-circle-fill"
					/>
				}>
				<MarkdownRender>{t('seznam.no-all-displayed')}</MarkdownRender>
			</GovMessage>
		</div>
	);
};
